import React, { Component } from 'react';
import Modal from "react-modal";

// CSS
import '../../css/country-select.css';

import countryCheck from '../../utils/countryCheck.js';

export class CountryPopup extends Component {
    constructor(props) {
        super(props);
        
        this.state = { isOpen: false };

        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount() {
        this.showModal();
    }

    async showModal() {
        if(!localStorage.getItem('countryCheck')) {
            localStorage.setItem('countryCheck', true);
            let check = await countryCheck();
            this.setState({ isOpen: check });
        }
	}

    redirectFromModal() {
        localStorage.setItem('sendToCA', true);
        window.location.href = "https://shop.fireoneup.ca";
    }

    closeModal() {
        this.setState({ isOpen: false });
    }

    render() {
        Modal.setAppElement('#root');
        return (
            this.state.isOpen && (
                <Modal
                    isOpen={this.state.isOpen}
                    contentLabel={'Country Select'}
                    className="country-modal-content" 
                    overlayClassName="country-overlay"
                    onRequestClose={this.closeModal}
                >
                    <div className="country-modal">
                        <h3 className="country-caption">Shopping from Canada? <span>Visit our Canadian Site!</span></h3>
                        <div 
                            className="left-option"
                            onClick={this.redirectFromModal}
                        >
                            <img 
                                src={require('../../images/country-flags/canada-250.png')}
                                alt="Canadian Flag"
                            />
                            <button className="btn">Visit <span>shop.fireoneup.ca</span></button>
                        </div>
                        <div 
                            className="right-option"
                            onClick={this.closeModal}
                        >
                            <img 
                                src={require('../../images/country-flags/us-250.png')}
                                alt="U.S. Flag"
                            />
                            <button className="btn">Continue to <span>Fire One Up USA</span></button>
                        </div>
                    </div>
                </Modal>
            )
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/utils/CountryPopup.js